// ⭐ URL base del backend (arreglo del login en producción, 2026-08-17).
//
// Mismo problema y misma solución que en marketos-landing/src/config/api.js
// (ver el comentario largo de ese archivo). Create React App, igual que Vite,
// sustituye process.env.REACT_APP_* por su valor literal durante el build: no
// es una variable que se lea al arrancar, es texto congelado en el bundle. Un
// build hecho sin REACT_APP_API_URL sirve para siempre "http://localhost:5000"
// a todos los navegadores, y el error que ve el usuario parece de red.
//
// La variable sigue mandando cuando está definida. Cuando falta, se decide por
// el host desde el que se sirve la página en lugar de asumir localhost.
const PRODUCTION_API_URL = 'https://saas-pos-multicategoria.onrender.com';
const LOCAL_API_URL = 'http://localhost:5000';

const isLocalHost = typeof window !== 'undefined'
  && /^(localhost|127\.0\.0\.1|\[::1\])$/.test(window.location.hostname);

const API_URL = process.env.REACT_APP_API_URL
  || (isLocalHost ? LOCAL_API_URL : PRODUCTION_API_URL);

export default API_URL;
